import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Product } from '../../interface/product/product';
import { HttpService } from '../http/http.service';
import { RawMaterial } from '../../interface';

@Injectable({
  providedIn: 'root'
})
export class RawMaterialsService {

  constructor(private _httpProduct: HttpService) { }

  public getAll(): Promise<RawMaterial[]> {
    return firstValueFrom(this._httpProduct.get('/RawMaterials'));
  }
  public getById(id: number): Promise<RawMaterial> {
    return firstValueFrom(this._httpProduct.get('/RawMaterials/'+ id));
  }
  public add(data: Product): Promise<RawMaterial> {
    return firstValueFrom(this._httpProduct.post('/RawMaterials', data));
  }
  public update(id: number, data: Product): Promise<RawMaterial> {
    return firstValueFrom(this._httpProduct.patch('/RawMaterials/', id, data));
  }
  public delete(id: number): Promise<RawMaterial> {
    return firstValueFrom(this._httpProduct.delete('/RawMaterials/', id));
  }
  public stock(id: number): Promise<any> {
    return firstValueFrom(this._httpProduct.get(`/RawMaterials/${id}/stock`));
  }
}
